import Model from './model'

export default class Vehicle extends Model {
    /**
     *
     * @returns {string}
     */
    get formattedFullVehicleName() {
        return this.formatted_name;
    }

    /**
     *
     * @returns {*}
     */
    static shortlisted() {
        return this.instance()
            .include(
                'vehicleMake',
                'transmission',
                'body',
                'condition',
                'color',
                'fuelType',
                'numberOfDoors',
                'drive',
                'media',
                'images',
                'company',
                'deals.buyer.companies',
                'deals.seller.companies',
            )
            .where('shortlisted', true)
            .get();
    }

    /**
     * Add to shortlist
     *
     * @returns {Promise<unknown>}
     */
    static addToShortlist(id) {
        return axios.post(`/${this.instance().resource()}/${id}/add-to-shortlist`);
    }

    /**
     * Add to shortlist
     *
     * @returns {Promise<unknown>}
     */
    static removeFromShortlist(id) {
        return axios.post(`/${this.instance().resource()}/${id}/remove-from-shortlist`)
    }

    /**
     * Clear shortlist
     *
     * @returns {*}
     */
    static clearShortlist() {
        return axios.post(`/${this.instance().resource()}/clear-shortlist`)
    }

    /**
     *
     * @returns {string}
     */
    resource() {
        return 'web-api/vehicle'
    }
}
